import { Button, Container, Typography } from '@cleartrip/ct-design-components'

export type InlineSectionErrorFallbackProps = {
  title: string
  /** Defaults to "Please try again" when omitted. Pass "" to hide the line. */
  description?: string
  onRetry?: () => void
  className?: string
}

/**
 * Compact fallback for SentryErrorBoundary around non-critical sections (SRP tools, home rails, itinerary aside).
 */
const InlineSectionErrorFallback = ({ title, description = 'Please try again', onRetry, className }: InlineSectionErrorFallbackProps) => (
  <Container role='alert' aria-live='polite' className={`py-4 px-2 flex flex-column flex-middle flex-center ${className ?? ''}`}>
    <Typography variant='B2'>{title}</Typography>
    {description !== '' ? (
      <Typography variant='P3' color='subheading' className='mt-2'>
        {description}
      </Typography>
    ) : null}
    {onRetry ? (
      <Button variant='contained' color='tertiary' className='mt-4' onClick={onRetry}>
        <Typography variant='P3' color='neutral' className='c-pointer'>
          Retry
        </Typography>
      </Button>
    ) : null}
  </Container>
)

export default InlineSectionErrorFallback
